@if(open) {
<otui-modal
  [visible]="open"
  [heading]="profile ? 'Edit Profile' : 'New Profile'"
  (closeModal)="close()"
  size="lg"
>
  <otui-card class="profile-editor-card">
    <form [formGroup]="profileForm" (ngSubmit)="save()" class="form-container">
      <div class="column">
        <lib-text-input
          label="Profile Name"
          formControlName="profileName"
        ></lib-text-input>
        <lib-text-input
          label="Occupation"
          formControlName="occupation"
          placeholder="What do you do?"
        ></lib-text-input>
        <lib-text-input
          label="Location"
          formControlName="location"
          placeholder="Where are you based?"
        ></lib-text-input>
        <lib-text-area
          label="Bio"
          formControlName="bio"
          placeholder="Share what people should know first."
          [rows]="4"
        ></lib-text-area>
        <lib-text-area
          label="Skills"
          formControlName="skills"
          placeholder="Comma-separated skills"
          [rows]="3"
        ></lib-text-area>
      </div>
      <div class="column">
        <lib-image-upload
          label="Profile Picture"
          (imageUpload)="onProfilePicUpload($event)"
          [currentImage]="profileForm.get('profilePic')?.value"
        ></lib-image-upload>
        <lib-image-upload
          label="Cover Picture"
          (imageUpload)="onCoverPicUpload($event)"
          [currentImage]="profileForm.get('coverPic')?.value"
        ></lib-image-upload>
        <lib-text-area
          label="Interests"
          formControlName="interests"
          placeholder="What communities and topics energize you?"
          [rows]="4"
        ></lib-text-area>
      </div>
    </form>
    <div class="dialog-actions">
      <otui-button
        variant="success"
        type="submit"
        (click)="save()"
        [disabled]="profileForm.invalid || isSaving"
        >{{ isSaving ? 'Saving...' : 'Submit' }}</otui-button
      >
      <otui-button
        variant="warning"
        type="button"
        (click)="close()"
        [disabled]="isSaving"
        >Cancel</otui-button
      >
    </div>
  </otui-card>
</otui-modal>
}
